export enum UserScopes {
  CentralHubView = 'CENTRAL_HUB_VIEW',
  CentralHubManage = 'CENTRAL_HUB_MANAGE',
  CentralHubOperatorsView = 'CENTRAL_HUB_OPERATORS_VIEW',
  CentralHubOperatorsManage = 'CENTRAL_HUB_OPERATORS_MANAGE',
  CentralHubOperatorView = 'CENTRAL_HUB_OPERATOR_VIEW',
  CentralHubOperatorManage = 'CENTRAL_HUB_OPERATOR_MANAGE',
  CentralHubOperatorGeneralInfoView = 'OPERATOR_GENERAL_INFO_VIEW',
  CentralHubOperatorGeneralInfoManage = 'OPERATOR_GENERAL_INFO_MANAGE',
  CentralHubLanguageCurrencyView = 'LANGUAGE_CURRENCY_VIEW',
  CentralHubLanguageCurrencyManage = 'LANGUAGE_CURRENCY_MANAGE',
  CentralHubOperatorLegalDocumentsView = 'OPERATOR_LEGAL_DOCUMENTS_VIEW',
  CentralHubOperatorLegalDocumentsManage = 'OPERATOR_LEGAL_DOCUMENTS_MANAGE',
  CentralHubOperatorLicensesView = 'OPERATOR_LICENSES_VIEW',
  CentralHubOperatorLicensesManage = 'OPERATOR_LICENSES_MANAGE',
  CentralHubOperatorWorkspaceOwnersView = 'workspace_owner.read',
  CentralHubOperatorWorkspaceOwnersManage = 'workspace_owner.write',
  CentralHubUserManagementView = 'CENTRAL_HUB_USER_MANAGEMENT_VIEW',
  CentralHubUserManagementManage = 'CENTRAL_HUB_USER_MANAGEMENT_MANAGE',
  CentralHubStaffManagementView = 'STAFF_MANAGEMENT_VIEW',
  CentralHubStaffManagementManage = 'STAFF_MANAGEMENT_MANAGE',
  CentralHubRolesPermissionsView = 'ROLES_PERMISSIONS_VIEW',
  CentralHubRolesPermissionManage = 'ROLES_PERMISSIONS_MANAGE',
  CentralHubCompaniesView = 'CENTRAL_HUB_COMPANIES_VIEW',
  CentralHubCompaniesManage = 'CENTRAL_HUB_COMPANIES_MANAGE',
  CentralHubCompanyView = 'CENTRAL_HUB_COMPANY_VIEW',
  CentralHubCompanyManage = 'CENTRAL_HUB_COMPANY_MANAGE',
  CentralHubCompanyGeneralView = 'COMPANY_GENERAL_VIEW',
  CentralHubCompanyGeneralManage = 'COMPANY_GENERAL_MANAGE',
  CentralHubUserInvite = 'user.invite',
  PlatformView = 'PLATFORM_VIEW',
  PlatformManage = 'PLATFORM_MANAGE',
  PlatformOperatorsView = 'PLATFORM_OPERATORS_VIEW',
  PlatformOperatorManage = 'PLATFORM_OPERATORS_MANAGE',
  PlatformOperatorGeneralSettingsView = 'PLATFORM_OPERATORS_GENERAL_VIEW',
  PlatformOperatorGeneralSettingsManage = 'PLATFORM_OPERATORS_GENERAL_MANAGE',
  PlatformOperatorCountriesView = 'COUNTRIES_VIEW',
  PlatformOperatorCountriesManage = 'COUNTRIES_MANAGE',
  PlatformOperatorWebsiteView = 'WEBSITE_VIEW',
  PlatformOperatorWebsiteManage = 'WEBSITE_MANAGE',
  PlatformOperatorUserSettingsView = 'USER_SETTINGS_VIEW',
  PlatformOperatorUserSettingsManage = 'USER_SETTINGS_MANAGE',
  PlatformAuthenticationView = 'PLAYER_AUTHENTIFICATION_VIEW',
  PlatformAuthenticationManage = 'PLAYER_AUTHENTIFICATION_MANAGE',
  PlatformAuthenticationRegistrationFormView = 'REGISTRATION_FORM_VIEW',
  PlatformAuthenticationRegistrationFormManage = 'REGISTRATION_FORM_MANAGE',
  PlatformAuthenticationSecurityView = 'SECURITY_VIEW',
  PlatformAuthenticationSecurityManage = 'SECURITY_MANAGE',
  PlatformAuthenticationKYCView = 'KYC_VIEW',
  PlatformAuthenticationKYCManage = 'KYC_MANAGE',
  PlatformAuthenticationProfileSettingsView = 'PROFILE_SETTINGS_VIEW',
  PlatformAuthenticationProfileSettingsManage = 'PROFILE_SETTINGS_MANAGE',
  PlatformThirdPartyView = 'OPERATOR_THIRD_PARTY_SERVICES_VIEW',
  PlatformThirdPartyManage = 'OPERATOR_THIRD_PARTY_SERVICES_MANAGE',
  PlatformOperatorThirdPartySportsView = 'THIRD_PARTY_SPORTS_VIEW',
  PlatformOperatorThirdPartyPaymentsView = 'THIRD_PARTY_PAYMENT_VIEW',
  PlatformOperatorThirdPartyCasinoView = 'THIRD_PARTY_CASINO_VIEW',
  PlatformOperatorThirdPartyLiveSupportView = 'THIRD_PARTY_LIVE_SUPPORT_VIEW',
  PlatformOperatorThirdPartySmsView = 'THIRD_PARTY_SMS_VIEW',
  PlatformOperatorThirdPartyEmailView = 'THIRD_PARTY_EMAIL_VIEW',
  PlatformOperatorThirdPartyToolsView = 'THIRD_PARTY_TOOLS_VIEW',
  PlatformOperatorThirdPartyKycView = 'THIRD_PARTY_KYC_VIEW',
  PlatformOperatorThirdPartyOthersView = 'THIRD_PARTY_OTHERS_VIEW',
  PlatformOperatorThirdPartySportsManage = 'THIRD_PARTY_SPORTS_MANAGE',
  PlatformOperatorThirdPartyPaymentsManage = 'THIRD_PARTY_PAYMENT_MANAGE',
  PlatformOperatorThirdPartyCasinoManage = 'THIRD_PARTY_CASINO_MANAGE',
  PlatformOperatorThirdPartyLiveSupportManage = 'THIRD_PARTY_LIVE_SUPPORT_MANAGE',
  PlatformOperatorThirdPartySmsManage = 'THIRD_PARTY_SMS_MANAGE',
  PlatformOperatorThirdPartyEmailManage = 'THIRD_PARTY_EMAIL_MANAGE',
  PlatformOperatorThirdPartyToolsManage = 'THIRD_PARTY_TOOLS_MANAGE',
  PlatformOperatorThirdPartyKycManage = 'THIRD_PARTY_KYC_MANAGE',
  PlatformOperatorThirdPartyOthersManage = 'THIRD_PARTY_OTHERS_MANAGE',
  ChangelogView = 'CHANGELOG_VIEW',
  ChangelogManage = 'CHANGELOG_MANAGE',
  QuickToolView = 'QUICK_TOOL_VIEW',
  QuickToolManage = 'QUICK_TOOL_EDIT',
  AggregatorView = 'AGGREGATOR_VIEW',
  AggregatorManage = 'AGGREGATOR_MANAGE',
  AggregatorOperatorsView = 'aggregator.operators.view',
  AggregatorOperatorsManage = 'aggregator.operators.edit',
  CrmView = 'crm.view',
  CrmManage = 'crm.manage',
  RmtView = 'rmt.view',
  RmtManage = 'rmt.manage',
}
